import React, { createContext, useContext, useState, ReactNode } from 'react';

export type ApiMode = 'external' | 'local';

interface ApiModeContextType {
  apiMode: ApiMode;
  setApiMode: (mode: ApiMode) => void;
  toggleApiMode: () => void;
}

const ApiModeContext = createContext<ApiModeContextType | undefined>(undefined);

interface ApiModeProviderProps {
  children: ReactNode;
}

export function ApiModeProvider({ children }: ApiModeProviderProps) {
  const [apiMode, setApiMode] = useState<ApiMode>('local');

  const toggleApiMode = () => {
    setApiMode(current => current === 'external' ? 'local' : 'external');
  };

  return (
    <ApiModeContext.Provider value={{ apiMode, setApiMode, toggleApiMode }}>
      {children}
    </ApiModeContext.Provider>
  );
}

export function useApiMode() {
  const context = useContext(ApiModeContext);
  if (context === undefined) {
    throw new Error('useApiMode must be used within an ApiModeProvider');
  }
  return context;
}
